import { render, staticRenderFns } from "./WritingPluginErrorNotification.vue?vue&type=template&id=2df5ea16&"
import script from "./WritingPluginErrorNotification.vue?vue&type=script&lang=js&"
export * from "./WritingPluginErrorNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports